module.exports = __webpack_public_path__ + "static/media/texture_02.5416aede.png";